export enum IresaActionEnum {
    GET_QUOTED_AVAILABILITY = "GetQuotedAvailability",
    CREATE_QUOTE = "CreateQuote",
    UPDATE_QUOTE = "UpdateQuote",
    CREATE_BOOKING = "CreateBooking",
    CANCEL_BOOKING = "CancelBooking",
    GET_BOOKING = "GetBooking",
    CREATE_CUSTOMER = "CreateCustomer",
    UPDATE_CUSTOMER = "UpdateCustomer",
    GET_CUSTOMER = "GetCustomer",
    SEARCH_CUSTOMER = "SearchCustomer",
    CREATE_PAYMENT = "CreatePayment",
    DELETE_PAYMENT = "DeletePayment",
    CREATE_OPTION = "CreateOption",
    CREATE_AVAILABILITY = "CreateAvailability",
    CONFIRM_AVAILABILITY = "ConfirmAvailability",
    CANCEL_AVAILABILITY = "CancelAvailability",
    CONFIRM_QUOTE = "ConfirmQuote",
    UPDATE_BOOKING = "UpdateBooking"
}

